import React from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import Select from '../../../common/forms/select/Select';
import FormFooter from '../../../common/forms/FormFooter';
import Loader from '../../../common/Loader';
import {
  isRequired,
  isValidBillingDate,
  isValidBillingTime,
  validateNumber,
} from '../../../../utils/validators';
import { enumToSelectOptions } from '../../../../utils/enum';
import { BILLING_DOCUMENT_TYPE } from '../../../../config/constants';

// ---- Formulario reducido para editar datos de cliente y emisión ----
export const BillingFormComprobanteElectronico = ({
  handleSubmit,
  loading,
}) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <h4>Datos del Cliente</h4>
      <FormGroup row>
        <FormItem label="Nombre / Razón Social" required>
          <Field
            name="fullName"
            component={TextInput}
            placeholder="Nombre o Razón Social"
            type="text"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Tipo de Documento" required>
          <Field
            name="documentType"
            component={Select}
            options={enumToSelectOptions(BILLING_DOCUMENT_TYPE)}
            placeholder="Tipo de Documento"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Número de Documento" required>
          <Field
            name="documentNumber"
            component={TextInput}
            placeholder="Número de Documento"
            type="text"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Email">
          <Field
            name="email"
            component={TextInput}
            placeholder="Email del Cliente"
            type="email"
          />
        </FormItem>
      </FormGroup>

      <h4>Datos de Emisión</h4>
      <FormGroup row>
        <FormItem label="Código de Agencia" required>
          <Field
            name="agencyCode"
            component={TextInput}
            placeholder="Código de Agencia"
            type="text"
            validate={[isRequired, validateNumber]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Fecha de Emisión" required>
          <Field
            name="issueDate"
            component={TextInput}
            placeholder="YYYY-MM-DD"
            type="text"
            validate={[isRequired, isValidBillingDate]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Hora de Emisión" required>
          <Field
            name="issueTime"
            component={TextInput}
            placeholder="HH:mm:ss"
            type="text"
            validate={[isRequired, isValidBillingTime]}
          />
        </FormItem>
      </FormGroup>

      <FormFooter />
    </Form>
  );
};

BillingFormComprobanteElectronico.propTypes = {
  loading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loading: !state.AccountingUnit.Billing.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'BillingFormComprobanteElectronico',
})(BillingFormComprobanteElectronico);

export default connect(mapStateToProps)(formComponent);
